"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Chip_1 = tslib_1.__importDefault(require("@mui/material/Chip"));
const Stack_1 = tslib_1.__importDefault(require("@mui/material/Stack"));
const SelectableChipGroup = (props) => {
    const { options, isSelected, onSelect, ...rest } = props;
    return (react_1.default.createElement(Stack_1.default, { direction: "row", gap: 1, rowGap: 1, flexWrap: "wrap", ...rest }, options?.map((option, idx) => {
        const { value, ...restChip } = option;
        const isChipSelected = isSelected ? isSelected(option?.value) : false;
        return (react_1.default.createElement(Chip_1.default, { key: `${option?.id}-${idx}`, color: isChipSelected ? "primary" : "default", clickable: true, component: "button", onClick: (e) => (onSelect ? onSelect(e, value) : null), ...restChip }));
    })));
};
exports.default = SelectableChipGroup;
